import React from 'react';
import './header-dummy.styles.scss';

const HeaderDummy = () => (
    <div className="header__dummy"></div>
);

export default HeaderDummy;
